import { integrateBookkeeping } from '../../api/admin';
import invalidationManager from './InvalidationManager';

const useIntegrateBookkeepingMutation = invalidationManager.createMutationHook({
  mutationFunction: async ({
    bookkeeper,
    companyId,
  }: {
    bookkeeper: string;
    companyId: string;
  }) => {
    const response = await integrateBookkeeping(bookkeeper, companyId);
    return response;
  },
});

export { useIntegrateBookkeepingMutation };
